import { Link, useNavigate } from "react-router-dom";
import Reveal from "@/components/Reveal";
import { ArrowUpRight, Check, Flame } from "lucide-react";

const Offers = () => {
  const navigate = useNavigate();
  return (
    <section data-testid="offers-section" className="relative border-t border-[#27331C] bg-[#0E140A]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-24 sm:py-32">
        <Reveal>
          <div className="flex items-baseline gap-4 mb-6">
            <span className="font-mono2 text-xs tracking-[0.3em] text-[var(--accent)]">04</span>
            <span className="h-px flex-1 bg-[#27331C]" />
            <span className="font-mono2 text-xs tracking-[0.3em] text-[#8A8C7E]">CHOOSE YOUR MOVE</span>
          </div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-[#F2F1E8] max-w-3xl">
            Two ways in.<br />
            <span className="italic font-light text-[var(--accent)]">Both end in growth.</span>
          </h2>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-2 gap-6">
          {/* Growth Call */}
          <Reveal>
            <div data-testid="offer-growth-card" className="hover-card-glow relative h-full rounded-3xl border-2 border-[var(--accent)] bg-[#0A0F08] p-8 sm:p-10 overflow-hidden">
              <div className="absolute -top-16 -right-16 w-56 h-56 rounded-full bg-[var(--accent)]/10 blur-[80px]" />
              <div className="flex items-center gap-2 mb-6">
                <Flame className="w-4 h-4 text-[var(--accent)]" />
                <span className="font-mono2 text-[10px] tracking-[0.3em] text-[var(--accent)]">MOST BOOKED</span>
              </div>
              <h3 className="font-display text-3xl sm:text-4xl text-[#F2F1E8]">The Growth Call</h3>
              <div className="mt-4 flex items-end gap-2">
                <span className="font-display text-6xl font-bold text-accent-gradient">₹999</span>
                <span className="pb-2 font-mono2 text-[10px] tracking-[0.2em] text-[#8A8C7E]">60 MIN · 1:1 · ONLINE</span>
              </div>
              <ul className="mt-7 space-y-3">
                {[
                  "Full diagnosis of why your brand isn't converting",
                  "A custom growth roadmap for your funnel, content & ads",
                  "Free detailed brand audit included",
                  "₹999 fully adjusted when you execute with us",
                ].map((t) => (
                  <li key={t} className="flex gap-3 text-sm text-[#B9BBAC]">
                    <Check className="w-4 h-4 text-[var(--accent)] shrink-0 mt-0.5" />
                    {t}
                  </li>
                ))}
              </ul>
              <button
                data-testid="offer-growth-cta"
                onClick={() => navigate("/book?plan=growth")}
                className="btn-accent animate-pulse-glow group mt-9 w-full flex items-center justify-center gap-3 font-semibold text-sm sm:text-base px-8 py-4"
              >
                Book the ₹999 Growth Call
                <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </button>
              <p className="mt-4 text-center font-mono2 text-[10px] tracking-[0.2em] text-[#8A8C7E]">
                SERIOUS FOUNDERS ONLY · 5 SLOTS / WEEK
              </p>
            </div>
          </Reveal>

          {/* Free Audit */}
          <Reveal delay={0.12}>
            <div data-testid="offer-audit-card" className="hover-card-glow h-full rounded-3xl border border-[#27331C] bg-[#0A0F08] p-8 sm:p-10 flex flex-col">
              <div className="flex items-center gap-2 mb-6">
                <span className="w-2 h-2 rounded-full bg-[#E4B54A]" />
                <span className="font-mono2 text-[10px] tracking-[0.3em] text-[#E4B54A]">START FREE</span>
              </div>
              <h3 className="font-display text-3xl sm:text-4xl text-[#F2F1E8]">The Free Brand Audit</h3>
              <div className="mt-4 flex items-end gap-2">
                <span className="font-display text-6xl font-bold text-[#F2F1E8]">₹0</span>
                <span className="pb-2 font-mono2 text-[10px] tracking-[0.2em] text-[#8A8C7E]">10 QUESTIONS · 3 MIN · INSTANT SCORE</span>
              </div>
              <ul className="mt-7 space-y-3 flex-1">
                {[
                  "Answer 10 brutally honest questions about your brand",
                  "Get your instant Brand Health Score out of 20",
                  "See exactly which areas are leaking money",
                  "Get your result and weakest areas instantly on email",
                ].map((t) => (
                  <li key={t} className="flex gap-3 text-sm text-[#B9BBAC]">
                    <Check className="w-4 h-4 text-[#E4B54A] shrink-0 mt-0.5" />
                    {t}
                  </li>
                ))}
              </ul>
              <Link
                to="/audit"
                data-testid="offer-audit-cta"
                className="group mt-9 w-full flex items-center justify-center gap-3 border border-[#27331C] text-[#F2F1E8] font-semibold text-sm sm:text-base px-8 py-4 rounded-full hover:border-[var(--accent)] hover:text-[var(--accent)] transition-all duration-300 hover:scale-[1.02]"
              >
                Get Your Free Brand Audit
                <ArrowUpRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
              </Link>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Offers;
